var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['input-box', _vm.effect]},[_c('div',{staticClass:"left"},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"right"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }